import { Component, OnInit } from '@angular/core';
import {BaseComponent} from '../base/base.component';
import {ApiService} from '../../services/api/api.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-floatingintro',
  templateUrl: './floatingintro.component.html',
  styleUrls: ['./floatingintro.component.scss'],
})
export class FloatingintroComponent extends BaseComponent implements OnInit {

  constructor(
      apiService: ApiService,
      private router: Router
  ) {
    super(apiService);
  }

  ngOnInit() {}

  joinClicked() {
    this.router.navigate([ '/signup-username' ]);
  }

  learnMoreClicked() {
    this.router.navigate([ '/learnmore' ]);
  }

}
